import { formatDateOrTime } from "@/utils";
import { Box } from "@mui/material";

export const columns: IColumn<TradeDataTypes>[] = [
  {
    name: "Entry Summary No.",
    key: "entrySummaryNumber",
    align: "center",
    width: "179px",
    component: (item) => {
      return (
        <Box style={{ whiteSpace: "nowrap" }}>
          {item?.entrySummaryNumber ?? "-"}
        </Box>
      );
    },
  },
  {
    name: "Entry Summary No+Line",
    key: "entryLine",
    align: "center",
    width: "142px",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>{item?.entryLine ?? "-"}</Box>
    ),
  },
  {
    name: "Filer Code",
    key: "filerCode",
    align: "center",
    width: "118px",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>{item?.filerCode ?? "-"}</Box>
    ),
  },
  {
    name: "Entry Type Code",
    key: "entryTypeCode",
    align: "center",
    width: "137px",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>{item?.entryTypeCode ?? "-"}</Box>
    ),
  },
  {
    name: "Exclusion Savings",
    key: "exclusionSavings",
    align: "center",
    width: "153px",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>
        {item?.exclusionSavings ?? "-"}
      </Box>
    ),
  },
  {
    name: "Importer Number",
    key: "importerNumber",
    align: "center",
    width: "147px",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>{item?.importerNumber ?? "-"}</Box>
    ),
  },
  {
    name: "Port of Entry",
    key: "portOfEntryCode",
    align: "center",
    width: "112px",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>{item?.portOfEntryCode ?? "-"}</Box>
    ),
  },
  {
    name: "Entry Date",
    key: "entryDate",
    align: "center",
    width: "123px",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>
        {(item?.entryDate && formatDateOrTime(item?.entryDate, "date")) ?? "-"}
      </Box>
    ),
  },
  {
    name: "Entry Summary Date",
    key: "entrySummaryDate",
    align: "center",
    width: "123px",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>
        {(item?.entrySummaryDate &&
          formatDateOrTime(new Date(Number(item?.entrySummaryDate)), "date")) ??
          "-"}
      </Box>
    ),
  },
  {
    name: "Entry Summary Create Date",
    key: "entrySummaryCreateDate",
    align: "center",
    component: (item) => (
      <Box style={{ whiteSpace: "nowrap" }}>
        {(item?.entrySummaryCreateDate &&
          formatDateOrTime(
            new Date(Number(item?.entrySummaryCreateDate)),
            "date"
          )) ??
          "-"}
      </Box>
    ),
  },
  {
    name: "Entry Summary Line Number",
    key: "entrySummaryLineNumber",
    align: "center",
  },
  {
    name: "Review Team Number",
    key: "reviewTeamNumber",
    align: "center",
  },
  {
    name: "Country Of Origin Code",
    key: "countryOfOriginCode",
    align: "center",
  },
  {
    name: "Country Of Export Code",
    key: "countryOfExportCode",
    align: "center",
  },
  {
    name: "Manufacturer ID",
    key: "manufacturerID",
    align: "center",
  },
  {
    name: "Foreign Exporter ID",
    key: "foreignExporterID",
    align: "center",
  },
  {
    name: "Line SPI Code",
    key: "lineSPICode",
    align: "center",
  },
  {
    name: "Standard Visa Number",
    key: "standardVisaNumber",
    align: "center",
  },
  {
    name: "Textile Category Code",
    key: "textileCategoryCode",
    align: "center",
  },
  {
    name: "Textile Category",
    key: "textileCategory",
    align: "center",
  },
  {
    name: "Tariff Ordinal Number",
    key: "tariffOrdinalNumber",
    align: "center",
  },
  {
    name: "Hts Number Full",
    key: "htsNumberFull",
    align: "center",
  },
  {
    name: "Line Tariff Quantity 1",
    key: "lineTariffQuantity1",
    align: "center",
  },
  {
    name: "hts 8 Digit",
    key: "hts8Digit",
    align: "center",
  },
  {
    name: "Line Tariff UOM 1 Code",
    key: "lineTariffUOM1Code",
    align: "center",
  },
  {
    name: "Line Tariff Quantity 2",
    key: "lineTariffQuantity2",
    align: "center",
  },
  {
    name: "Line Tariff UOM 2 Code",
    key: "lineTariffUOM2Code",
    align: "center",
  },
  {
    name: "Line Tariff Quantity 3",
    key: "lineTariffQuantity3",
    align: "center",
  },
  {
    name: "Line Tariff UOM 3 Code",
    key: "lineTariffUOM3Code",
    align: "center",
  },
  {
    name: "Line Tariff Goods Value Amount",
    key: "lineTariffGoodsValueAmount",
    align: "center",
  },
  {
    name: "Line Tariff Duty Amount",
    key: "lineTariffDutyAmount",
    align: "center",
  },
  {
    name: "Related Party Indicator",
    key: "relatedPartyIndicator",
    align: "center",
  },
  {
    name: "Entry Date Seconds",
    key: "entryDateSeconds",
    align: "center",
  },
  {
    name: "Ch 98",
    key: "ch98",
    align: "center",
  },
  {
    name: "Ch 99",
    key: "ch99",
    align: "center",
  },
  {
    name: "Ch 98 Code",
    key: "ch98Code",
    align: "center",
  },
  {
    name: "Ch 99 Code",
    key: "ch99Code",
    align: "center",
  },
  {
    name: "Ch 99 Code 2",
    key: "ch99Code2",
    align: "center",
  },
  {
    name: "MTB",
    key: "mtb",
    align: "center",
  },
  {
    name: "Sec 201",
    key: "sec201",
    align: "center",
  },
  {
    name: "Sec 232",
    key: "sec232",
    align: "center",
  },
  {
    name: "Sec 301",
    key: "sec301",
    align: "center",
  },
  {
    name: "Exclusions",
    key: "exclusions",
    align: "center",
  },
  {
    name: "Mfn Duty",
    key: "mfnDuty",
    align: "center",
  },
  {
    name: "Mtb Duty",
    key: "mtbDuty",
    align: "center",
  },
  {
    name: "Duty 201",
    key: "duty201",
    align: "center",
  },
  {
    name: "Duty 232",
    key: "duty232",
    align: "center",
  },
  {
    name: "Duty 301",
    key: "duty301",
    align: "center",
  },
  {
    name: "Sec 301 List",
    key: "sec301List",
    align: "center",
  },
  {
    name: "Total Estimated MPF Amount",
    key: "totalEstimatedMPFAmount",
    align: "center",
  },
  {
    name: "Total Estimated HMF Amount",
    key: "totalEstimatedHMFAmount",
    align: "center",
  },
  {
    name: "Total Estimated Other Fee Amount",
    key: "totalEstimatedOtherFeeAmount",
    align: "center",
  },
  {
    name: "Total Estimated Fee Amount",
    key: "totalEstimatedFeeAmount",
    align: "center",
  },
  {
    name: "Reconciliation Indicator",
    key: "reconciliationIndicator",
    align: "center",
  },
  {
    name: "Reconciliation Issue",
    key: "reconciliationIssue",
    align: "center",
  },
  {
    name: "Duty Savings",
    key: "dutySavings",
    align: "center",
  },
  {
    name: "Rate",
    key: "rate",
    align: "center",
  },
  {
    name: "Count",
    key: "count",
    align: "center",
  },
  {
    name: "Line MPF Amount",
    key: "lineMPFAmount",
    align: "center",
  },
  {
    name: "Line HMF Amount",
    key: "lineHMFAmount",
    align: "center",
  },
  {
    name: "Unique Indicator",
    key: "uniqueIndicator",
    align: "center",
  },
  {
    name: "Filtered Out",
    key: "filteredOut",
    align: "center",
  },
  {
    name: "Paid Not Paid",
    key: "paidNotPaid",
    align: "center",
  },
  {
    name: "Mpf Factor",
    key: "mpfFactor",
    align: "center",
  },
  {
    name: "Original File",
    key: "originalFile",
    align: "center",
  },
  {
    name: "Header Fee File",
    key: "headerFeeFile",
    align: "center",
  },
  {
    name: "Line Free File",
    key: "lineFreeFile",
    align: "center",
  },
  {
    name: "Mpf Table File",
    key: "mpfTableFile",
    align: "center",
  },
  {
    name: "To Adjust",
    key: "toAdjust",
    align: "center",
  },
  {
    name: "Revised MPF",
    key: "revisedMPF",
    align: "center",
  },
];

export const defaultVisibleColumns = [
  "entryLine",
  "entryDate",
  "countryOfOriginCode",
  "manufacturerID",
  "htsNumberFull",
  "lineTariffGoodsValueAmount",
  "lineTariffDutyAmount",
];
